////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import React, {useState} from 'react';
import Theme from "@adsk/alloy-react-theme";
import TextInput from "@adsk/alloy-react-text-input";
import {FlexColumn} from "../CommonStyledComponents";

const SettingsGeneral = ({name, description, showDescription, onChange}: {
  name: string | undefined,
  description: string | undefined,
  showDescription: boolean,
  onChange?: (value: string, field: 'name' | 'description') => void
}) => {
  const [internalName, setInternalName] = useState(name ?? '');
  const [internalDescription, setInternalDescription] = useState(description ?? '');

  function sendUpdate(field: 'name' | 'description'): void {
    let value = '';
    switch (field) {
      case "name":
        value = internalName;
        break;
      case "description":
        value = internalDescription;
        break;
    }

    if (onChange) {
      onChange(value, field);
    }
  }

  return (
    <FlexColumn>
      <h2 style={Theme.typography.heading2}>Name</h2>
      <TextInput value={internalName}
                 placeholder={'Enter a task name...'}
                 onKeyDown={() => sendUpdate('name')}
                 onChange={v => setInternalName(v.target.value)}
                 onBlur={() => sendUpdate('name')}/>
      {
        showDescription &&
        <>
          <h2 style={Theme.typography.heading2}>Description</h2>
          <TextInput value={internalDescription}
                     placeholder={'Enter a task description (optional)...'}
                     onKeyDown={() => sendUpdate('description')}
                     onChange={v => setInternalDescription(v.target.value)}
                     onBlur={() => sendUpdate('description')}/>
        </>
      }
    </FlexColumn>
  );
};


export default SettingsGeneral;